import { NgIf } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { TitleComponent } from '@app/shared/components/title/title.component';
import { UnitService } from '@app/shared/services';
import { ReadOnly } from '@app/utils/claims';
import { CreditCardSetupComponent } from './credit-card-setup/credit-card-setup.component';
import { PurchaseCardSetupComponent } from './purchase-card-setup/purchase-card-setup.component';
import { VirtualCardSetupComponent } from './virtual-card-setup/virtual-card-setup.component';

@Component({
	selector: 'payment-card-setup',
	templateUrl: './payment-card-setup.component.html',
	styleUrls: ['./payment-card-setup.component.less'],
	standalone: true,
	imports: [
		TitleComponent,
		MatCardModule,
		MatTabsModule,
		PurchaseCardSetupComponent,
		NgIf,
		CreditCardSetupComponent,
		VirtualCardSetupComponent,
	],
})
export class PaymentCardSetupComponent implements OnInit {
	@ViewChild('purchaseCardSetupComponent') purchaseCardSetupComponent: PurchaseCardSetupComponent;
	@ViewChild('creditCardSetupComponent') creditCardSetupComponent: CreditCardSetupComponent;
	@ViewChild('virtualCardSetupComponent') virtualCardSetupComponent: VirtualCardSetupComponent;

	@HostListener('window:beforeunload')
	canDeactivate = (): boolean => this.CanDeactivate();

	@ReadOnly() isReadOnly = false;

	virtualCardEnabled = false;
	creditCardEnabled = false;

	constructor(protected readonly unitService: UnitService) {}

	ngOnInit(): void {
		this.unitService.getValue('EnabledVirtualCreditCards').subscribe((result) => {
			if (result.isValid) {
				this.virtualCardEnabled = result.value === 'true' || result.value === 'True';
				this.creditCardEnabled = result.value === 'true' || result.value === 'True';
			}
		});
	}

	public CanDeactivate(): boolean {
		return (
			this.purchaseCardSetupComponent.CanDeactivate() &&
			(!this.virtualCardEnabled || this.virtualCardSetupComponent.CanDeactivate()) &&
			(!this.creditCardEnabled || this.creditCardSetupComponent.CanDeactivate())
		);
	}
}
